import { Image } from "@/components/UI-Kit/Helper classes/image";

export class Icon extends Image {
  baseIcon = "";
  constructor(src, alt, baseIcon) {
    super(src, alt);
    this.baseIcon = baseIcon;
  }
}
